export enum ApiRoutes {
  STATS = "/api/v1/stats",
  FILTERS_OPTIONS = "/api/v1/filters/options",
  TRANSACTIONS = "/api/v1/transactions",
  TRANSACTIONS_PER_STORE = "/api/v1/transactions/per-store",
  TRANSACTIONS_LIVE = "/api/v1/transactions/live",
  REVENUE = "/api/v1/revenue",
  INVOICES = "/api/v1/invoices",
  USERS_ACTIVE = "/api/v1/users/active",
  PRODUCTS_TOP = "/api/v1/products/top",
  COUPONS_TOP = "/api/v1/coupons/top",
  COUPONS_AVAILABLE = "/api/v2/coupons/available",
  COUPONS = "/api/v1/coupons",
  CUSTOMERS = "/api/v1/customers",
  CUSTOMERS_STATS = "/api/v1/customers/stats",
  CUSTOMERS_DETAILS = "/api/v1/customers/details",
  CSV_DATA = "/api/v1/csv-data",
  ME = "/api/v1/auth/me",
  ADMIN_CHECK = "/api/v1/auth/check-admin",
  AUTH_LOGIN = "/api/v1/auth/login",
  PROMO_MESSAGES = "/api/promo-messages",
  // Recepti — standalone Recipes API (documentation/features/Recipes.md).
  // Proxied + bearer-injected by src/pages/api/recepti/[[...slug]].ts because
  // it lives on its own host, separate from the rest of the v1/v2 API —
  // shares the STATS_API_TOKEN bearer, not a separate secret.
  RECEPTI = "/api/recepti",
  // Current deals ("Ponude"). Routed through the v2 proxy to the dev deals
  // service; the proxy special-cases `current_deals` onto the shared bearer.
  DEALS = "/api/v2/current_deals",
  EXPORT_CUSTOMERS = "/api/v1/users/export",
  FIRELOG = "/api/v1/firelog",
  // GDPR usage logging (login + page views) into Supabase, same-origin route.
  USAGE_LOG = "/api/usage-log",
  SEND_PUSH = "/api/v1/send-push",
  PUSH_NOTIFICATIONS = "/api/v1/notifications/push",
  ASSIGN_REWARD_POINTS = "/api/v1/customers/assign",
  NOTIFICATIONS = "/api/v1/notifications",
  NOTIFICATION_RECIPIENTS = "/api/v1/notifications/:id/recipients",

  // Manual campaigns / stats API (v2) — proxied + bearer-injected by
  // src/pages/api/v2/[...slug].ts. Per-id paths are built in the service.
  MANUAL_CAMPAIGNS = "/api/v2/manual-campaigns/campaigns",
  MANUAL_CAMPAIGNS_PREVIEW = "/api/v2/manual-campaigns/preview",
  MANUAL_CAMPAIGNS_CATEGORIES = "/api/v2/manual-campaigns/categories",
  MANUAL_CAMPAIGNS_STORES = "/api/v2/manual-campaigns/stores",
  MANUAL_CAMPAIGNS_PRODUCT_GROUPS = "/api/v2/manual-campaigns/product-groups",
  // Automatic campaigns (campaign_configs). Per-key paths built in the service.
  AUTOMATIC_CAMPAIGNS = "/api/v2/campaigns",

  // Stores ("Poslovnice") API (v2) — served by the products_stores service on
  // the dev host. Proxied + bearer-injected by src/pages/api/v2/[...slug].ts.
  // Per-id paths are built in the service.
  STORES = "/api/v2/products_stores/stores",

  // Per-store STATS (getStoreStats/compare) live on the staging stats-api under
  // the bare `stores` prefix — NOT the dev products_stores CRUD service above.
  // The v2 proxy routes `stores` to the stats host + STATS_API_TOKEN.
  STORE_STATS = "/api/v2/stores",

  // Stats API (v2) — Home tab. Proxied + bearer-injected by
  // src/pages/api/v2/[...slug].ts. See documentation/features/01-home-stats.md.
  STATS_HOME_SUMMARY = "/api/v2/stats/home/summary",
  STATS_MAU_MONTHLY = "/api/v2/stats/mau-monthly",
  STATS_RECEIPTS_BY_HOUR = "/api/v2/stats/receipts-by-hour",
  STATS_AVG_TRANSACTION = "/api/v2/stats/avg-transaction",
  STATS_MOST_VISITED_STORES = "/api/v2/stats/most-visited-stores",
  STATS_RANK_DISTRIBUTION = "/api/v2/customers/rank-distribution",
  STATS_TRANSACTIONS_LIVE = "/api/v2/transactions/live",
  STATS_TRANSACTIONS_PER_STORE = "/api/v2/transactions/per-store",
  STATS_COUPONS_TOP = "/api/v2/coupons/top",
  // Per-coupon analytics keyed by nft_id — demographics/peak paths built inline
  // as `${STATS_COUPONS}/${nft_id}/demographics|peak`.
  STATS_COUPONS = "/api/v2/coupons",

  // Stats API (v2) — Products tab. Proxied + bearer-injected by
  // src/pages/api/v2/[...slug].ts. See documentation/features/02-products-stats.md.
  STATS_PRODUCTS = "/api/v2/products",
  STATS_CATEGORIES = "/api/v2/categories",
  STATS_PRODUCT_GROUPS = "/api/v2/product-groups",
  STATS_PRODUCTS_DEMOGRAPHICS = "/api/v2/products/demographics",
  STATS_PRODUCTS_PEAK = "/api/v2/products/peak",
  STATS_PRODUCTS_TOTALS = "/api/v2/products/totals",
  STATS_PRODUCTS_BASKET = "/api/v2/products/basket",

  // Legal documents & consents ("Dokumenti i privole"). These live on a
  // different host (NEXT_PUBLIC_DEV_MINCH_API_URL) than the rest of the v2
  // API, so they use a dedicated proxy — src/pages/api/legal/[...slug].ts —
  // which maps /api/legal/* → ${DEV}/api/v2/legal/* and injects the
  // STATS_API_TOKEN bearer server-side. Per-id paths are built in the
  // service. See documentation/features/Endpoint Contract (2).md.
  LEGAL_DOCUMENTS = "/api/legal/documents",
  LEGAL_CONSENTS = "/api/legal/consents",
  LEGAL_ADMIN_DOCUMENTS = "/api/legal/admin/documents",
  LEGAL_ADMIN_CONSENTS = "/api/legal/admin/consents",
}
